export default "__VITE_ASSET__ByKjCaz9__"